import { MainButton, TabButton } from 'src/styles/button.style';
import theme from 'src/theme';
import styled from 'styled-components';

export const BunkeringContainerStyle = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
`;

export const BunkerRegistrationContainerStyle = styled.div`
    flex: 1;
    width: 100%;
    display: flex;
    flex-direction: row;
    gap: 8px;
    background-color: ${theme.colors.background.lightGrey};
`;

export const BunkerRegPageLeftWrapper = styled.div`
    flex: 1.2;
    display: flex;
    flex-direction: column;
    gap: 8px;
    height: 100%;
`;

export const BunkeringRegTableWrapper = styled.div`
    padding: 0px 3px;
    flex: 1;
    background-color: ${theme.colors.background.white};
`;

export const BunkeringRegStatusWrapper = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0px 3px;
    flex: 1;
    overflow-y: auto;
    background-color: ${theme.colors.background.white};
`;

export const BunkeringRegTableStyle = styled.table`
    width: 100%;
    border-collapse: collapse;
    > thead {
        height: 31px;
    }
`;

type TableColumnHeaderProps = {
    width?: string;
};

export const TableColumnHeaderStyle = styled.th<TableColumnHeaderProps>`
    width: ${(props) => props.width || 'auto'};
    padding: 0.2rem;
    text-align: left;
    border-bottom: 1px solid ${theme.legacyColors.darkBlue};
    background-color: ${theme.legacyColors.headerBackground};
`;

type BunkeringRegListItemProps = {
    selected?: boolean;
};

export const BunkeringRegListItemStyle = styled.tr<BunkeringRegListItemProps>`
    cursor: pointer;
    ${(props) => props.selected && `background-color: ${theme.legacyColors.selectedBackground}`};
    &:hover {
        ${(props) => !props.selected && `background-color: ${theme.legacyColors.hoverBackground}`};
    }
`;

export const BunkerRegFormWrapper = styled.div`
    flex: 2;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0px 3px;
    background-color: ${theme.colors.background.white};
`;

export const BunkerFormHeader = styled.div`
    flex: 0 0 auto;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: 1px solid ${theme.legacyColors.darkBlue};
    background-color: ${theme.legacyColors.headerBackground};
`;

export const BunkerRegTabsWrapper = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    width: 100%;
`;

export const BunkerRegTabButton = styled(TabButton)`
    height: 31px;
    padding: 4px 8px;
`;

export const BunkerRegInputSectionsWrapper = styled.div`
    display: flex;
    flex-direction: row;
    overflow-y: hidden;
    gap: 16px;
    width: 100%;
    flex: 1;
    justify-content: center;
`;

export const BunkerRegSectionHeader = styled.div`
    height: 31px;
    border-bottom: 1px solid ${theme.legacyColors.selectedBorder};
    display: flex;
`;

export const BunkerRegColumnWrapper = styled.div`
    width: 100%;
    max-height: 100%;
    max-width: 480px;
    padding: 8px 0px;

    overflow-y: auto;
`;

type BunkerRegInputGridProps = {
    unitFieldWidth?: number;
};

export const BunkerRegInputGrid = styled.div<BunkerRegInputGridProps>`
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
    width: 100%;
    max-height: 100%;
    margin-bottom: 8px;
    label .input-value-wrapper .input-unit {
        width: ${(props) => (props.unitFieldWidth ? `${props.unitFieldWidth}px` : '60px')}; !important;
    }
`;

export const BunkerRegInputRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
    padding-right: 44px;
`;

type InputComponentWrapperProps = {
    inputFieldWidth?: number;
};

export const InputComponentWrapper = styled.div<InputComponentWrapperProps>`
    label .input-value-wrapper .input-value {
        input {
            ${(props) => props.inputFieldWidth && `width: ${props.inputFieldWidth}px;`}
        }
    }
`;

export const AssignDebunkeringButtonWrapper = styled.div`
    display: flex;
    justify-content: center;
    padding-top: 20px;
`;

export const CheckboxWrapper = styled.div`
    width: 100%;
    & > * {
        width: 100%;
    }
    label .input-value-wrapper .input-unit {
        width: 55px; !important;
    }
`;

export const BunkeringStatusListWrapper = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    padding-top: 4px;
`;

export const BunkeringStatusHeader = styled.div`
    flex: 0 1 auto;
    text-align: center;
    border-bottom: 1px solid ${theme.legacyColors.darkBlue};
    padding: 2px;
`;

export const BunkeringStatusChangeWrapper = styled.div`
    flex: 0 1 auto;
    padding-top: 8px;
    display: flex;
    flex-direction: column;
    gap: 2px;
    text-align: center;
`;

export const BunkeringStatusChangeOptionsWrapper = styled.div`
    display: flex;
    justify-content: center;
    gap: 4px;
    padding: 8px 0px;
`;

export const ActiveFromDateWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
`;

export const BunkeringStatusChangeNote = styled.div`
    padding-top: 8px;
    text-align: center;
    font-size: 0.9rem;
`;

export const DatePickerWrapper = styled.div`
    .ant-picker {
        width: 150px;
    }
`;

export const BunkeringStatusButton = styled(MainButton)`
    ${(props) => props.disabled && `opacity: 0.5; cursor: not-allowed;`}
    padding: 4px 10px;
`;

export const BunkeringStatusTableStyle = styled.table`
    flex: 1;
    height: 100%;
    width: 100%;
    border-collapse: collapse;

    .ant-picker {
        width: 150px;
    }
    .ant-picker-input {
        input {
            width: 60px !important;
        }
    }
`;

export const BunkeringStatusTableRowStyle = styled.tr`
    display: table;
    width: 100%;
    table-layout: fixed;
`;

export const FuelReceivedWrapper = styled.div`
    flex: 1;
    width: 100%;
    overflow: hidden;
`;

export const FuelReceivedTableStyle = styled.table`
    height: 100%;
    width: 100%;
`;

export const FuelReceivedTableHeadStyle = styled.thead`
    background-color: ${theme.legacyColors.headerBackground};
    width: 100%;
`;

export const FuelReceivedTableBodyStyle = styled.tbody`
    overflow-y: auto;
    height: 100%;
    display: block;
    width: 100%;
`;

export const FuelReceivedTableRowStyle = styled.tr`
    display: table;
    width: 100%;
    table-layout: fixed;
    th {
        text-align: left;
        border-bottom: 1px solid ${theme.legacyColors.darkBlue};
    }
    th:nth-child(1) {
        width: 25.5%;
    }
    th:nth-child(2) {
        width: 12%;
    }
    th:nth-child(3) {
        width: 10%;
    }
    th:nth-child(4) {
        width: 15%;
    }
    th:nth-child(5) {
        width: 17.5%;
    }
    th:nth-child(6) {
        width: 20%;
        text-align: center;
    }
    td {
        border-bottom: 1px solid ${theme.legacyColors.selectedBorder};
    }
    td:nth-child(1) {
        width: 25.5%;
    }
    td:nth-child(2) {
        width: 12%;
    }
    td:nth-child(3) {
        width: 10%;
    }
    td:nth-child(4) {
        width: 15%;
    }
    td:nth-child(5) {
        width: 17.5%;
    }
    td:nth-child(6) {
        width: 20%;
    }
`;

export const BunkerRegistrationTankStyle = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const DebunkeringItemWrapper = styled(BunkeringRegListItemStyle)`
    background-color: ${theme.legacyColors.highlightBackground};
    border-top: 1px solid ${theme.legacyColors.orangeBorderColor};
    border-bottom: 1px solid ${theme.legacyColors.orangeBorderColor};
`;
